import React from "react";
import { useState, useEffect } from "react";
import Masonry from "react-masonry-css";
import PostCard from "../postcard/Postcard";
import "./Homepage.css";
import Menu from "../menu/Menu";

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1,
};

export default function HomePage({ posts }) {
  const API_URL = process.env.REACT_APP_API_URL;

  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/me`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data && setUser(data));
  }, []);

  return (
    <div>
      <Menu user={user} setUser={setUser} />
      <div className="HomepagePadding flex items-center">
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
        >
          {posts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </Masonry>
      </div>
    </div>
  );
}
